import React, { useMemo } from "react";

/**
 * Sakura petals falling - pure CSS, very subtle, decorative.
 * Renders N absolutely positioned petals with randomised animation
 * delays/durations for a natural feel. Pointer-events: none.
 */
const PETAL_COUNT = 18;

const Petal = ({ i }) => {
  const left = Math.random() * 100;
  const delay = Math.random() * 12;
  const duration = 12 + Math.random() * 14;
  const size = 10 + Math.random() * 14;
  const drift = (Math.random() * 80 - 40).toFixed(0);
  const rotateStart = Math.floor(Math.random() * 360);
  const rotateEnd = rotateStart + 360 + Math.floor(Math.random() * 360);
  const opacity = 0.35 + Math.random() * 0.45;

  return (
    <span
      className="sakura-petal"
      style={{
        left: `${left}%`,
        width: `${size}px`,
        height: `${size}px`,
        opacity,
        animationDelay: `-${delay}s`,
        animationDuration: `${duration}s`,
        "--drift": `${drift}px`,
        "--rotate-start": `${rotateStart}deg`,
        "--rotate-end": `${rotateEnd}deg`,
      }}
      aria-hidden="true"
    />
  );
};

const SakuraPetals = () => {
  const petals = useMemo(() => Array.from({ length: PETAL_COUNT }, (_, i) => i), []);
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden z-[3]" aria-hidden="true" data-testid="sakura-overlay">
      {petals.map((i) => <Petal key={i} i={i} />)}
    </div>
  );
};

export default SakuraPetals;
